const timeFrameLengthMap = {
  SHORT_TIME_FRAME: 3,
  FULL_DAY_TIME_FRAME: 7,
} as const;

const timeFrameTypes = {
  SHORT: 'SHORT',
  EXTENDED: 'EXTENDED',
  FULL_DAY: 'FULL_DAY',
} as const;

export type TimeFrameType = (typeof timeFrameTypes)[keyof typeof timeFrameTypes];

interface Timeframe {
  from?: string | number | Date | null;
  to?: string | number | Date | null;
}

const timeFrameLength = (first: Date, second: Date): number => {
  const between = Math.abs(first.getTime() - second.getTime());
  return between / (3600 * 1000);
};

const getTypeByTimeFrame = (timeframe: Timeframe): TimeFrameType => {
  const hours = timeFrameLength(new Date(timeframe.from ?? NaN), new Date(timeframe.to ?? NaN));
  if (hours <= timeFrameLengthMap.SHORT_TIME_FRAME) {
    return timeFrameTypes.SHORT;
  } else if (hours < timeFrameLengthMap.FULL_DAY_TIME_FRAME) {
    return timeFrameTypes.EXTENDED;
  } else {
    return timeFrameTypes.FULL_DAY;
  }
};

export { timeFrameTypes, getTypeByTimeFrame };
